<ul class="uploaded-versions">
    <li *ngFor="let version of versions | sortBy: 'id' : 'desc'" class="uploaded-version_li" >
        <versions-summary-status-box 
            [version]="version"
            [uploaded]="true"
            [feedbacks]="getFeedbacks(version)"
            [menu]="menu"
            (menuClick)="onMenuClick($event)"
            (menuStatusClick)="updateVersionStatus($event,version)"
            (actionFileClick)="onFileClick(version,$event)"
        ></versions-summary-status-box>
    </li>
</ul>